import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const CLIENT = "ca-pub-8255937483037669";
const MIN_WORDS = 300;
const TIMEOUT_MS = 20000;

/**
 * Alleen echte contentpagina's mogen Google Auto ads tonen.
 * NIET: /rijschool/:slug, stads-/plaatspagina's, auth, admin, formulieren, 404.
 */
const ALLOWED: RegExp[] = [
  /^\/$/,
  /^\/rijscholen\/?$/,
  /^\/online-theorie\/?$/,
  /^\/(theorie-)?boeken\/?$/,
  /^\/tweewielers\/?$/,
  /^\/code95\/?$/,
  /^\/taxi\/?$/,
  /^\/cbr\/?$/,
  /^\/videos\/?$/,
  /^\/reviews\/?$/,
  /^\/nieuws\/?$/,
  /^\/verenigingen\/?$/,
  /^\/vacatures\/?$/,
  /^\/partners\/?$/,
  /^\/blog\/?$/,
  /^\/verhaal\/[^/]+\/?$/,
  /^\/nieuws\/[^/]+\/?$/,
  /^\/reviews\/cbr-2026-de-grote-ommekeer\/?$/,
  /^\/over-ons\/?$/,
];

export const isAdAllowedPath = (path: string) => ALLOWED.some((r) => r.test(path));

const countMainWords = () => {
  const main = document.querySelector("main");
  if (!main) return 0;
  return (main.textContent || "").trim().split(/\s+/).filter((w) => w.length > 1).length;
};

const isReady = () => document.querySelector("main")?.getAttribute("data-ad-ready") === "true";

const isLoading = () =>
  !!document.querySelector("main .animate-spin, main [aria-busy='true'], [role='dialog']");

const removePlacedAds = () => {
  document
    .querySelectorAll("ins.adsbygoogle, .google-auto-placed, iframe[id^='aswift_'], .adsbygoogle-noablate")
    .forEach((el) => el.remove());
};

export const AdSenseLoader = () => {
  const { pathname } = useLocation();
  const scriptLoaded = useRef(false);

  useEffect(() => {
    const body = document.body;
    body.classList.add("no-ads");

    if (!isAdAllowedPath(pathname)) {
      // Script is al geladen: Auto ads kunnen niet betrouwbaar worden uitgezet,
      // dus volledige reload naar deze niet-toegestane pagina.
      if (scriptLoaded.current || document.getElementById("adsense-script")) {
        removePlacedAds();
        window.location.reload();
      }
      return;
    }

    const start = Date.now();
    const timer = window.setInterval(() => {
      if (isReady() && !isLoading() && countMainWords() >= MIN_WORDS) {
        window.clearInterval(timer);
        body.classList.remove("no-ads");
        if (!document.getElementById("adsense-script")) {
          const s = document.createElement("script");
          s.id = "adsense-script";
          s.async = true;
          s.crossOrigin = "anonymous";
          s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
          document.head.appendChild(s);
          scriptLoaded.current = true;
        }
      } else if (Date.now() - start > TIMEOUT_MS) {
        window.clearInterval(timer);
      }
    }, 500);
    return () => window.clearInterval(timer);
  }, [pathname]);

  return null;
};
